export interface PerformanceManagerResponseInterface<T> {
  status: string;
  data: T;
}

export enum BalancingPageKpis {
  SOC_SPREAD = 'soc_spread',
  VOLTAGE_SPREAD = 'voltage_spread',
}

export enum TemperatureKpis {
  TEMPERATURE_SPREAD = 'temperature_spread',
  TEMPERATURE_MEAN = 'temperature_mean',
  TEMPERATURE_MAX = 'temperature_max',
}

export enum PerformanceManagerKPI {
  SOC_SPREAD = 'soc_spread',
  VOLTAGE_SPREAD = 'voltage_spread',
  TEMPERATURE_SPREAD = 'temperature_spread',
  TEMPERATURE_MEAN = 'temperature_mean',
  TEMPERATURE_MAX = 'temperature_max',
}

export enum BalancingSeverityEnum {
  CRITICAL = 'high',
  ELEVATED = 'medium',
  NORMAL = 'balanced',
  MISSING = 'missing',
}

export enum InsightSeverity {
  Critical = 'critical',
  Elevated = 'elevated',
  High = 'high',
  Medium = 'medium',
}

export interface SeverityLevelParams {
  customerBk: string;
  systemBk: string;
}

export interface SeverityLevelData {
  severityLevel: string;
  lowerBoundary: number;
  upperBoundary: number;
}

export interface SystemSeverityResponse {
  customerBk?: string;
  systemBk?: string;
  data: { [key: string]: SeverityLevelData[] };
}

export interface AggregationLevelBkParams {
  customerBk: string;
  systemBk: string;
}

export interface AggregationLevelBkResponse {
  customerBk?: string;
  syestemBk?: string;
  aggregationLevelBk?: string;
}

export interface SystemStatisticsParams {
  customerBk: string;
  systemBk: string;
  kpi: PerformanceManagerKPI | BalancingPageKpis | TemperatureKpis;
  aggregationLevelBk: string;
  startDate: number;
  endDate: number;
}

export interface SystemStatisticsData {
  x: number;
  y: {
    [key: string]: number;
  };
  kpi?: PerformanceManagerKPI;
}

export interface SystemStatisticsResponse {
  customerBk?: string;
  systemBk?: string;
  kpi?: PerformanceManagerKPI;
  data: SystemStatisticsData[];
}

export interface SystemKPIParams {
  customerBk: string;
  systemBk: string;
  kpi: PerformanceManagerKPI | BalancingPageKpis | TemperatureKpis;
  levelBk: string;
  date: number;
}

export interface SystemKPIData {
  componentBk: string;
  inverterName?: string | undefined;
  enclosureBk?: string | undefined;
  dcCombinerBk?: string | undefined;
  eventDate: number;
  severityLevel: string;
  value?: number;
}

export interface SystemKPIResponse {
  customerBk?: string;
  systemBk?: string;
  levelBk?: string;
  kpi?: PerformanceManagerKPI;
  data: SystemKPIData[];
}

export interface SystemInsightsParams {
  customerBk: string;
  systemBk: string;
  kpi: PerformanceManagerKPI | BalancingPageKpis | TemperatureKpis;
  date: number;
}

export interface SystemInsightsData {
  enclosureBk?: string;
  dcCombinerBk?: string;
  inverterBk?: string;
  severity: InsightSeverity;
  mostCritical: string;
  spread: number;
}

export interface SystemInsightsResponse {
  customerBk?: string;
  systemBk?: string;
  kpi?: PerformanceManagerKPI;
  data: SystemInsightsData[];
  levelBk: string;
}

export interface StringKPIParams {
  customerBk: string;
  systemBk: string;
  kpi: PerformanceManagerKPI | BalancingPageKpis | TemperatureKpis;
  startDate: number;
  endDate: number;
  parentComponentBk: string;
}

export interface StringKPIData {
  componentBk: string;
  eventDate: number;
  severityLevel: string;
  value?: number;
  enclosureBk?: string;
  dcCombinerBk?: string;
  inverterBk?: string;
}

export interface StringKPIResponse {
  customerBk?: string;
  systemBk?: string;
  kpi?: PerformanceManagerKPI;
  parentComponentBk?: string;
  data: StringKPIData[];
}

export interface StringThroughputParams {
  startDate: number;
  endDate: number;
  parentComponentBk: string | null;
}

export interface StringThroughputData {
  componentBk: string;
  timestamp: string;
  value: number | null;
}

export interface StringThroughputResponse {
  levelBk: string;
  data: StringThroughputData[];
}

export interface TooltipContent {
  content: string;
  style: string;
}
